var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogfleetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4401 7.59991e-05L19.187 3.78524e-05C17.6178 -0.000310044 15.9378 -0.000682466 14.4874 0.117825C12.8513 0.251503 10.7154 0.580629 8.51781 1.70037C5.58251 3.196 3.196 5.58248 1.70037 8.51779C0.580629 10.7154 0.251503 12.8512 0.117825 14.4874C-0.000682466 15.9378 -0.000310045 17.6177 3.78525e-05 19.1869L7.60119e-05 19.44V24H8.8V19.4214C8.8 17.645 8.8 16.2874 8.88853 15.2039C8.97773 14.112 9.15885 13.2632 9.54115 12.5129C10.1931 11.2334 11.2334 10.1931 12.5129 9.5412C13.2632 9.15891 14.112 8.97779 15.2039 8.88856C16.2874 8.80005 17.6449 8.80005 19.4214 8.80005H32.0003V7.59991e-05H19.4401ZM32.0003 9.60005H19.44C17.6412 9.60005 16.3162 9.60035 15.2691 9.68592C14.2266 9.77109 13.4948 9.93875 12.8761 10.254C11.7471 10.8293 10.8292 11.7471 10.2539 12.8761C9.93869 13.4948 9.77104 14.2266 9.68587 15.2691C9.60032 16.3162 9.6 17.6413 9.6 19.44V24H18.4001V19.44C18.4001 19.0599 18.4001 18.7162 18.4008 18.4008C18.7162 18.4001 19.06 18.4 19.4401 18.4H32.0003V9.60005Z",
    fill: "#0FB7DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogfleetLogo);
export default __webpack_public_path__ + "static/media/logfleet_logo.c3257049a04bec3e23b8838aaea6454b.svg";
export { ForwardRef as ReactComponent };